///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Pipe, PipeTransform } from '@angular/core';
import { GtthDuplicatedNodeFeatureDto } from '../model/duplicated-node-feature-dto.model';

@Pipe({
    name: 'sortByDistance',
    standalone: false
})
export class GtthSortByDistancePipe implements PipeTransform {
    transform(items: GtthDuplicatedNodeFeatureDto[]): GtthDuplicatedNodeFeatureDto[] {
        if (!items) return [] as GtthDuplicatedNodeFeatureDto[];
        if (items.length <= 1) return items;
        return items.sort((item1, item2) => item1.getDistance() - item2.getDistance());
    }
}
